module.exports = __webpack_public_path__ + "img/visa.23dac400.svg";